import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unset } from './MissingData'

const key = IdentificationUrlKeys.ProximityId
const label = 'proximityID'

export const proximityIdColumn = () =>
  columnHelper.display({
    id: 'proximityId',
    header: 'Proximity ID',
    cell: ({ row }) => {
      const proximityId = row.original.proximity?.id

      if (!proximityId) {
        return <Unset />
      }

      return (
        <CellAction copyValue={proximityId} search={(old) => ({ ...old, [key]: proximityId })} field={label}>
          <Typography className='font-mono'>{proximityId}</Typography>
        </CellAction>
      )
    },
  })
